import { Text, View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.8cm',
    paddingBottom: '0.3cm',
    borderBottom: '2px solid #548235',
  },
  transferContainer: {
    backgroundColor: '#f8f9fa',
    borderRadius: '0.3cm',
    border: '1px solid #e8e8e8',
    padding: '0.8cm',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  bankInfo: {
    marginBottom: '0.6cm',
  },
  bankName: {
    fontSize: '12px',
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    marginBottom: '0.2cm',
  },
  accountInfo: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.4,
    marginBottom: '0.1cm',
  },
  accountNumber: {
    fontSize: '12px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    marginBottom: '0.2cm',
  },
  holderInfo: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.4,
    marginBottom: '0.1cm',
  },
  extraInfo: {
    fontSize: '10px',
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginTop: '0.4cm',
    paddingTop: '0.4cm',
    borderTop: '1px solid #e8e8e8',
    textAlign: 'justify',
  },
});

function BudgetDataTransfer({ staticData = {} }) {
  return (
    <View wrap={false}>
      <Text style={styles.title}>5. Datos de Transferencia</Text>

      <View style={styles.transferContainer}>
        {/* Información del banco */}
        <View style={styles.bankInfo}>
          <Text style={styles.bankName}>{staticData?.bank}</Text>
          <Text style={styles.accountInfo}>{staticData?.account_type}</Text>
        </View>

        {/* Número de cuenta destacado */}
        <Text style={styles.accountNumber}>
          N° {staticData?.account_number}
        </Text>

        {/* Información del titular */}
        <View style={styles.holderInfo}>
          <Text style={styles.holderInfo}>{staticData?.account_holder}</Text>
          {/* No eliminar el {} porque si se elimina no aparece el digito verificador */}
          <Text style={styles.holderInfo}>
            {staticData?.rut} {}
          </Text>
          <Text style={styles.holderInfo}>{staticData?.email}</Text>
        </View>

        {/* Información adicional */}
        {staticData?.extra && (
          <Text style={styles.extraInfo}>{staticData?.extra}</Text>
        )}
      </View>
    </View>
  );
}

export default BudgetDataTransfer;
